<template>
    <div class="lb-inspiration-preview">
        <div :style="imageBackground" id="discover">
            <section
                class="
                    section
                    is-large
                    lb-inspiration-header
                    has-text-centered has-text-white
                "
            >
                <p
                    v-t="$t('Inspirations.discover_project')"
                    class="is-size-4 is-uppercase has-text-weight-bold"
                ></p>
                <p
                    v-t="
                        content.title
                            ? content.title
                            : $t('Inspirations.title_default')
                    "
                    class="is-size-2 has-text-weight-bold"
                ></p>
                <div class="has-text-white has-text-centered mt-4">
                    <p>
                        <b>{{ $t('Inspirations.creation.duration') }}: </b
                        ><span
                            v-html="
                                content.duration
                                    ? content.duration
                                    : $t('Inspirations.duration_default')
                            "
                        />
                    </p>

                    <p>
                        <b>{{ $t('Inspirations.creation.level') }}: </b
                        ><span
                            v-html="
                                content.level
                                    ? content.level
                                    : $t('Inspirations.level_default')
                            "
                        />
                    </p>
                </div>
            </section>
        </div>

        <section class="lb-inspiration-introduction" id="introduction">
            <div class="container">
                <div class="pb-6">
                    <span
                        class="
                            is-size-4 is-uppercase
                            has-text-weight-bold
                            has-text-primary
                            has-bottom-line
                        "
                    >
                        {{ $t('Inspirations.introduction') }}
                    </span>
                </div>
                <div
                    class="is-size-6 has-text-left"
                    v-html="
                        content.introduction
                            ? content.introduction
                            : $t('Inspirations.introduction_default')
                    "
                ></div>
            </div>
        </section>

        <section class="lb-inspiration-project-type" id="project-type">
            <div class="container">
                <div class="pb-6">
                    <span
                        class="
                            is-size-4 is-uppercase
                            has-text-weight-bold
                            has-text-primary
                            has-bottom-line
                        "
                    >
                        {{ $t('Inspirations.used_project_type') }}
                    </span>
                </div>
                <div
                    v-if="content.projectType.length"
                    class="columns is-mobile is-multiline is-centered"
                >
                    <div
                        v-for="projectType in content.projectType"
                        :key="projectType.name"
                        class="
                            py-2
                            column
                            is-3
                            has-text-centered
                            px-0
                            mb-0
                            has-cursor-pointer
                        "
                    >
                        <div :ref="projectType" class="box mx-2 px-2 py-2">
                            <figure class="image is-2by1">
                                <img :src="projectTypeImage(projectType)" />
                            </figure>
                            <p>
                                {{
                                    $t(
                                        'Inspirations.project_type.' +
                                            projectType
                                    )
                                }}
                            </p>
                        </div>
                    </div>
                </div>
                <div v-else class="columns is-mobile is-multiline is-centered">
                    <div class="column is-4-desktop is-6-tablet">
                        <div class="box mx-2 px-2 py-2">
                            <figure class="image is-2by1">
                                <img
                                    :src="
                                        require('@/assets/images/contentmap_old.png')
                                    "
                                />
                            </figure>
                            <p>
                                {{ $t('Inspirations.project_type_show.MAP') }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section lb-inspiration-zones" id="zones">
            <div class="columns is-multiline">
                <div class="column is-4">
                    <div
                        class="
                            has-background-info-light has-text-centered
                            py-6
                            px-5
                        "
                    >
                        <span class="icon is-large has-text-primary">
                            <i
                                class="mdi mdi-3r mdi-brain pt-5"
                                aria-hidden="true"
                            />
                        </span>
                        <p
                            class="
                                is-size-5
                                has-text-primary has-text-weight-bold
                                py-3
                            "
                        >
                            Soft Skills
                        </p>
                        <p
                            class="is-size-6 pt-1"
                            v-html="
                                content.softSkills
                                    ? content.softSkills
                                    : $t('Inspirations.soft_skills_default')
                            "
                        ></p>
                    </div>
                </div>

                <div class="column is-4">
                    <div
                        class="
                            has-background-info-light has-text-centered
                            py-6
                            px-5
                        "
                    >
                        <span class="icon is-large has-text-primary">
                            <i
                                class="
                                    mdi mdi-3r mdi-head-snowflake-outline
                                    pt-5
                                "
                                aria-hidden="true"
                            />
                        </span>
                        <p
                            class="
                                is-size-5
                                has-text-primary has-text-weight-bold
                                py-3
                            "
                        >
                            {{ $t('Inspirations.key_competences') }}
                        </p>
                        <div
                            v-if="content.keyCompetences.length"
                            class="is-size-6"
                        >
                            <p
                                v-for="competence in content.keyCompetences"
                                :key="competence"
                                class="pb-2"
                            >
                                {{
                                    $t('Inspirations.competence.' + competence)
                                }}
                            </p>
                        </div>
                        <p v-else>
                            Proin vitae lectus tortor. Praesent non feugiat
                            nibh, sed mattis massa. Nam euismod, nibh quis
                            pellentesque imperdiet, libero sem pulvinar massa,
                            id aliquet nisl arcu ac sapien. Duis gravida libero
                            a lectus pulvinar facilisis.
                        </p>
                    </div>
                </div>

                <div class="column is-4">
                    <div
                        class="
                            has-background-info-light has-text-centered
                            py-6
                            px-5
                        "
                    >
                        <span class="icon is-large has-text-primary">
                            <i
                                class="mdi mdi-3r mdi-folder-open-outline pt-5"
                                aria-hidden="true"
                            />
                        </span>
                        <p
                            class="
                                is-size-5
                                has-text-primary has-text-weight-bold
                                py-3
                            "
                        >
                            {{ $t('Inspirations.subjects') }}
                        </p>
                        <div v-if="content.subjects.length" class="is-size-6">
                            <p
                                v-for="subject in content.subjects"
                                :key="subject"
                                class="pb-2"
                            >
                                {{ $t('Inspirations.subject.' + subject) }}
                            </p>
                        </div>
                        <p v-else>
                            Proin vitae lectus tortor. Praesent non feugiat
                            nibh, sed mattis massa. Nam euismod, nibh quis
                            pellentesque imperdiet, libero sem pulvinar massa,
                            id aliquet nisl arcu ac sapien. Duis gravida libero
                            a lectus pulvinar facilisis. Donec non mi vel arcu
                            blandit aliquet eget nec velit.
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <section class="lb-inspiration-objectives" id="objectives">
            <div class="container">
                <div class="pb-6">
                    <span
                        class="
                            is-size-4 is-uppercase
                            has-text-weight-bold
                            has-text-primary
                            has-bottom-line
                        "
                    >
                        {{ $t('Inspirations.objectives') }}
                    </span>
                </div>
                <div
                    class="is-size-6 has-text-centered pb-6"
                    v-html="
                        content.learningObjectives
                            ? content.learningObjectives
                            : $t('Inspirations.soft_skills_default')
                    "
                ></div>
            </div>
        </section>

        <section class="lb-inspiration-proposals" id="proposals">
            <div class="container">
                <div class="pb-6">
                    <span
                        class="
                            is-size-4 is-uppercase
                            has-text-weight-bold
                            has-text-primary
                            has-bottom-line
                        "
                    >
                        {{ $t('Inspirations.proposals') }}
                    </span>
                </div>
                <div v-if="content.activities.length">
                    <div
                        v-for="(activity, index) in content.activities"
                        :key="index"
                    >
                        <article class="media pb-4">
                            <figure
                                class="
                                    media-left
                                    has-background-primary
                                    mr-1
                                    px-2
                                    py-2
                                "
                            >
                                <p
                                    class="
                                        image
                                        is-64x64
                                        has-text-white
                                        is-size-2
                                        has-text-weight-bold
                                        pt-1
                                    "
                                >
                                    {{ index + 1 }}
                                </p>
                            </figure>
                            <div
                                class="
                                    media-content
                                    has-background-info-light
                                    px-5
                                    py-5
                                "
                            >
                                <div
                                    class="content has-text-left"
                                    v-html="activity"
                                ></div>
                            </div>
                        </article>
                    </div>
                </div>
                <div v-else>
                    <article class="media pb-4">
                        <figure
                            class="
                                media-left
                                has-background-primary
                                mr-1
                                px-2
                                py-2
                            "
                        >
                            <p
                                class="
                                    image
                                    is-64x64
                                    has-text-white
                                    is-size-2
                                    has-text-weight-bold
                                    pt-1
                                "
                            >
                                1
                            </p>
                        </figure>
                        <div
                            class="
                                media-content
                                has-background-info-light
                                px-5
                                py-5
                            "
                        >
                            <div
                                class="content has-text-left"
                                v-html="$t('Inspirations.proposals_default')"
                            ></div>
                        </div>
                    </article>
                </div>
            </div>
        </section>

        <section class="lb-inspiration-project" id="project">
            <div class="">
                <div class="pb-6">
                    <span
                        class="
                            is-size-4 is-uppercase
                            has-text-weight-bold
                            has-text-primary
                            has-bottom-line
                        "
                    >
                        {{ $t('Inspirations.result') }}
                    </span>
                </div>

                <div v-if="hasProject" class="mb-6">
                    <div class="has-text-centered">
                        <a
                            :href="content.project"
                            class="button lb-button is-primary mb-6"
                            target="_blank"
                            >{{ $t('Inspirations.show_project') }}</a
                        >
                    </div>
                    <iframe
                        width="100%"
                        height="900px"
                        :src="projectUrl"
                    ></iframe>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import _ from 'underscore';
export default {
    components: {},
    props: {
        content: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    computed: {
        imageBackground() {
            console.log(this.content.image);
            if (this.content.image) {
                return (
                    "background-image: url('" +
                    this.content.image.url +
                    "'); background-size: cover; background-repeat: no-repeat; background-position: center center;"
                );
            }
            return '';
        },
        hasProject() {
            /*console.log(
                this.content.project,
                process.env.VUE_APP_SHARE_ROOT_URL
            );*/
            return (
                this.content.project &&
                (this.content.project.includes(
                    process.env.VUE_APP_SHARE_ROOT_URL
                ) ||
                    this.content.project.includes(
                        process.env.VUE_APP_SHARE_ROOT_URL_LABYGRAM
                    ) ||
                    this.content.project.includes(
                        process.env.VUE_APP_SHARE_ROOT_URL_LABYLOK
                    ))
            );
        },
        projectUrl() {
            let urlArray = this.content.project.split('/');

            /*console.log(
                'projectUrl',
                process.env.VUE_APP_SHARE_ROOT_URL +
                    urlArray[urlArray.length - 1]
            );*/
            return (
                process.env.VUE_APP_SHARE_ROOT_URL +
                urlArray[urlArray.length - 1]
            );
        },
    },
    methods: {
        projectTypeImage(name) {
            let projectTypeData = _.filter(
                this.$store.state.Project.PROJECT_TYPE,
                (projectType) => {
                    return projectType.name == name;
                }
            );
            return projectTypeData[0].image;
        },
    },
};
</script>

<style scooped>
.lb-inspiration-header {
    background-blend-mode: multiply;
    background-image: linear-gradient(
        to bottom,
        rgba(74, 74, 74, 0.72),
        rgba(74, 74, 74, 0.72)
    );
}
.lb-inspiration-preview {
    max-height: calc(100vh - 48px);
    overflow-y: auto;
}
.lb-inspiration-introduction,
.lb-inspiration-project-type,
.lb-inspiration-objectives,
.lb-inspiration-proposals {
    padding: 5rem 10rem 0 10rem;
    text-align: center;
}
.has-bottom-line {
    border-bottom: 2px solid;
    padding: 0.5rem;
}
.lb-inspiration-projects .box {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
    border-radius: none;
}
.mdi-3r {
    font-size: 3rem;
}
.lb-inspiration-zones .column .has-background-info-light {
    min-height: 350px;
}
.lb-inspiration-proposals .media-left,
.lb-inspiration-proposals .media-content {
    border-radius: 4px;
}
.lb-inspiration-project {
    padding: 5rem 0 0 0;
    text-align: center;
}
</style>
